import {createDefaultStyle, TDBaseShape, TDShapeType} from '@modules/whiteboard'
import {CardImageSourceSettings} from '@stores'

export interface CatalogItemCardShape extends TDBaseShape {
  type: 'catalogItem'
  size: number[]
  cardData: {
    showDetailsPopover?: boolean
    itemId?: string
    imageId?: string
    workspace?: string
    visibleFields?: string[]
    view?: 'builderCard' | 'listPreviewCard'
    imageSource?: CardImageSourceSettings

    sizes?: {
      builderCardSize: number[]
      listPreviewSize: number[]
    }
  }

  verticalAlign?: 'top' | 'centerVertical' | 'bottom'
  horizontalAlign?: 'left' | 'centerHorizontal' | 'right'
}

// export class CatalogItemCardShape implements ICatalogItemCardShape {
//   cardData: { showDetailsPopover?: boolean; itemId?: string; imageId?: string; workspace?: string; visibleFields?: string[]; view?: "builderCard" | "listPreviewCard"; imageSource?: CardImageSourceSettings }
//   childIndex: number
//   id: string
//   name: string
//   parentId: string
//   point: number[]
//   size: number[]
//   rotation = 0
//   style = createDefaultStyle()
//   type: "catalogItem" = 'catalogItem'
// }

export * from './CatalogItemShapeStore'
export * from './CatalogItemShapeComponent'
export * from './CatalogItemShapeUtil'
export * from './CatalogItemShapeIndicator'



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/catalogItem/index.ts